module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0083.jpg?v=f8c67267";